import {
  ONBOARDING_ADD_IMAGE,
  ONBOARDING_REMOVE_IMAGE
} from '../../constants/actions';

const initialState = {
  images: {}
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case ONBOARDING_ADD_IMAGE:
      let images = {...state.images, [action.imgIndex]: {img: action.img, thumb: action.thumb}};
      return {
        ...state,
        images
      };
    case ONBOARDING_REMOVE_IMAGE:
      let imgs = {...state.images};
      delete imgs[action.imgIndex];
      return {
        images: imgs
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/onboardingUploadImage.js